import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function Login() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'content-type': 'application/json',
          'x-demo-passcode': import.meta.env.VITE_DEMO_PASSCODE ?? 'arizona-c2-demo',
        },
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) {
        let detail = 'Login failed.';
        try {
          const j = await res.json();
          detail = (j as { detail?: string }).detail ?? detail;
        } catch {
          /* ignore */
        }
        throw new Error(detail);
      }
      await refresh();
      navigate('/');
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Login failed.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand">
          <span className="dot" />
          <h1>AriZona <span className="c2">C2</span></h1>
        </div>
        <div className="ph" style={{ marginBottom: 4 }}>Strategy Control Surface</div>
        <div className="login-tagline" style={{ marginBottom: 14 }}>Big Can since 1992 · 99¢</div>
        <div className="lead" style={{ fontSize: 14, marginBottom: 20 }}>
          Sign in to access the C2 surface. Single shared credential per environment.
        </div>

        {err && <div className="login-err">{err}</div>}

        <div className="login-field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            required
            autoComplete="email"
            className="c2-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
          />
        </div>

        <div className="login-field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            required
            autoComplete="current-password"
            className="c2-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
        </div>

        <button type="submit" className="btn primary" disabled={busy} style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <div className="small faint" style={{ marginTop: 16, fontSize: 12, textAlign: 'center' }}>
          Demo environment. Not real authentication beyond a single user.
        </div>
      </form>
    </div>
  );
}
